import { SearchCheck, Handshake, FlaskConical, ClipboardCheck, CalendarClock, Ship } from "lucide-react";
import { Reveal, SectionTag } from "@/components/Reveal";

const SERVICES = [
  {
    icon: SearchCheck,
    title: "Supplier Identification & Vetting",
    desc: "Factory shortlisting, capacity checks, compliance screening and physical verification.",
  },
  {
    icon: Handshake,
    title: "Price Discovery & Negotiation",
    desc: "Multi-vendor benchmarking and direct factory negotiation to secure the best landed cost.",
  },
  {
    icon: FlaskConical,
    title: "Sampling & Product Development",
    desc: "Spec sheets, tech packs, counter samples and golden sample approval before bulk.",
  },
  {
    icon: ClipboardCheck,
    title: "Quality Control & Inspection",
    desc: "In-line and pre-shipment inspection with AQL-based reporting and photo evidence.",
  },
  {
    icon: CalendarClock,
    title: "Production Follow-Up",
    desc: "Weekly status tracking against the shipment calendar so delays surface early.",
  },
  {
    icon: Ship,
    title: "Export Logistics & Documentation",
    desc: "Consolidation, freight booking, customs clearance and complete export paperwork.",
  },
];

export const Services = () => (
  <section id="services" className="relative py-28 lg:py-40 bg-[#F4F7FC]" data-testid="services-section">
    <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
      <Reveal>
        <SectionTag index="02" label="What We Do" />
      </Reveal>
      <Reveal>
        <h2 className="font-display font-semibold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#0A1B33] max-w-3xl mb-20" data-testid="services-heading">
          End-to-end sourcing, <span className="text-[#2E7FE0]">under one roof.</span>
        </h2>
      </Reveal>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#2E7FE0]/12 border border-[#2E7FE0]/12 rounded-2xl overflow-hidden">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06} className="h-full">
            <div
              className="group bg-white hover:bg-[#F0F6FE] p-10 lg:p-12 h-full transition-colors duration-500"
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start justify-between mb-10">
                <s.icon className="w-8 h-8 text-[#2E7FE0] transition-transform duration-500 group-hover:-translate-y-1" />
                <span className="font-mono2 text-xs text-[#54678A]/50">/{String(i + 1).padStart(2, "0")}</span>
              </div>
              <h3 className="font-display font-semibold text-xl lg:text-2xl text-[#0A1B33] mb-4 leading-snug">
                {s.title}
              </h3>
              <p className="text-[#54678A] text-sm leading-relaxed">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
